import { EmployeeDetailsOutput } from './employee-details-output.model';


export class EmployeeDetailsSelectByIdOutput implements IEmployeeDetailsSelectByIdOutput {
    status!: number;
    message!: string;
    data!: EmployeeDetailsOutput;

    constructor(data?: IEmployeeDetailsSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? EmployeeDetailsOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeDetailsSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEmployeeDetailsSelectByIdOutput {
    status: number;
    message: string;
    data: EmployeeDetailsOutput;
}

